import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { SignedIn, SignedOut, RedirectToSignIn, useAuth } from "@clerk/clerk-react";
export function RequireAuth({ children }) {
    return (_jsxs(_Fragment, { children: [_jsx(SignedIn, { children: children }), _jsx(SignedOut, { children: _jsx(RedirectToSignIn, {}) })] }));
}
// Authenticated fetch — attaches Clerk session token to the request.
export function useApi() {
    const { getToken } = useAuth();
    return async (path, init = {}) => {
        const token = await getToken();
        const headers = new Headers(init.headers || {});
        if (token)
            headers.set("Authorization", `Bearer ${token}`);
        if (init.body && !headers.has("Content-Type"))
            headers.set("Content-Type", "application/json");
        const res = await fetch(path, { ...init, headers });
        if (!res.ok)
            throw new Error(`API ${res.status}: ${await res.text()}`);
        return res.json();
    };
}
